import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getNonStructuredSectionSchedulesAction } from '../actions';

const {
  useLoader: useNonStructuredSectionSchedulesLoader,
  useLoaderData: useNonStructuredSectionSchedulesLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getNonStructuredSectionSchedulesAction,
});

function NonStructuredSectionSchedulesLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  NonStructuredSectionSchedulesLoader,
  useNonStructuredSectionSchedulesLoader,
  useNonStructuredSectionSchedulesLoaderData,
};
